import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import ResponsivenessScoreContainer from 'apps/responsiveness-score/components/responsiveness-score-container';
import request from 'superagent';

const fetchData = url => request.get(url);

export default function initResponsivenessScore(node, ChildComponent) {
    const intlData = JSON.parse(node.getAttribute('data-responsiveness-score-translation-map'));
    const url = node.getAttribute('data-responsiveness-score-url');

    ReactDOM.render(
        (
            <IntlProvider locale={intlData.locale} messages={intlData.messages}>
                <ResponsivenessScoreContainer fetchData={() => fetchData(url)}>
                    <ChildComponent />
                </ResponsivenessScoreContainer>
            </IntlProvider>
        ),
        node,
    );
}



// WEBPACK FOOTER //
// ./src/js/apps/responsiveness-score/index.jsx